import { get, isEmpty } from "lodash-es";
import { FieldError, FieldErrors, FieldPath, FieldValues } from "react-hook-form";

export function getMaybeErrorMessage<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(errors: FieldErrors<TFieldValues>, path: TName): string | undefined {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const error: FieldError | undefined = get(errors, path) as any;
    if (error == null) {
        return undefined;
    }

    return getMessageFromFieldError(error);
}

function getMessageFromFieldError({ root, message, type }: FieldError): string {
    if (root != null) {
        return getMessageFromFieldError(root);
    }

    if (message != null && !isEmpty(message)) {
        return message;
    }

    switch (type) {
        case "required":
            return "Required";
        case "pattern":
        case "matches":
        case "typeError":
            return "Invalid format";
        default:
            return "";
    }
}
